import { RootState } from 'redux-store/store'

export const locationSelector = (state: RootState) => state.location
